import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Send, Plus } from "lucide-react";
import BeatLoader from "react-spinners/BeatLoader";

const ChatInput = ({
  inputValue,
  onInputChange,
  onSubmit,
  onFileSelect,
  isSending,
  isLoading,
  isAuthenticated,
  hasFiles,
  isSellerCountLoading,
  messageLimitCheck
}) => {
  return (
    <form onSubmit={onSubmit} className="flex w-full items-center space-x-2">
      <input
        type="file"
        id="chatFileUpload"
        className="hidden"
        multiple
        accept="image/*,video/*"
        onChange={onFileSelect}
      />

      <Button
        type="button"
        size="icon"
        variant="outline"
        onClick={() => document.getElementById("chatFileUpload")?.click()}
        disabled={isSending || isLoading || !isAuthenticated}
      >
        <Plus className="h-5 w-5" />
      </Button>

      <Input
        id="partMessage"
        placeholder="Type your message..."
        className="flex-1"
        autoComplete="off"
        value={inputValue}
        onChange={onInputChange}
        disabled={isSending || isLoading || !isAuthenticated}
      />

      <Button
        type="submit"
        size="icon"
        disabled={
          (!inputValue.trim() && !hasFiles) ||
          isSending ||
          isLoading ||
          !isAuthenticated ||
          isSellerCountLoading ||
          messageLimitCheck
        }
      >
        {isSending ? (
          <BeatLoader color="white" size={6} />
        ) : (
          <Send className="h-4 w-4" />
        )}
      </Button>
    </form>
  );
};

export default ChatInput;
